function formatAmount(amount) {
    if (amount >= 1e7) {
        return (amount / 1e7).toFixed(2) + ' Cr'; // Crore (10 Million)
    // } else if (amount >= 1e6) {
    //     return (amount / 1e6).toFixed(2) + ' M'; // Million
    // } else if (amount >= 1e5) {
    //     return (amount / 1e5).toFixed(2) + ' L'; // Lakh (100 Thousand)
    // } else if (amount >= 1e3) {
    //     return (amount / 1e3).toFixed(2) + ' K'; // Thousand
    } else {
        return amount; // Less than Thousand
    }
}

export default formatAmount;